<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { FeaturePanelSidebar } from '~/components/feature/panel-sidebar'
import { CreditLockView } from '~/components/feature/profile'

const { t } = useI18n()
const { getPathWithLocale } = useLocalizedPath()

const breadcrumbs = [
  { title: t('page.panel.breadcrumb'), url: '/panel' },
  { title: t('page.panel.credit_lock.breadcrumb'), url: '/panel/credit-lock' }
]

const { isLoggedIn } = useUser()

if (!isLoggedIn.value) {
  await navigateTo(getPathWithLocale('/login'))
}
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <ContentBlock variant="white">
          <CreditLockView />
        </ContentBlock>
        <template #right-sidebar>
          <FeaturePanelSidebar />
        </template>
      </ContentLayout>
    </Container>
  </Main>
</template>